var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11 16.423-6-2.1-3.958 1.53a.74.74 0 0 1-.713-.083.73.73 0 0 1-.329-.636V2.904q0-.268.13-.489a.69.69 0 0 1 .378-.307L5 .577l6 2.1 3.958-1.53a.79.79 0 0 1 .713.054q.33.197.329.587v12.385a.8.8 0 0 1-.159.498.84.84 0 0 1-.425.298zm-.5-1.22v-11.7l-5-1.745v11.7zm1 0L15 14.05V2.2l-3.5 1.304zM1 14.8l3.5-1.342v-11.7L1 2.95z"
  })));
};
export default SvgMap;